/**
 * Handles the passkey retrieval and submission of the passkey
 * */
import { parseRequestOptionsFromJSON } from '../util/webauthnPolyfills';

export async function loginWithPasskey(
    requestCredentialOptionsJSON: PublicKeyCredentialRequestOptionsJSON,
    formId: string,
    conditionalMediation: boolean = false,
): Promise<void> {
    // Check if WebAuthn is usable
    if (!window.PublicKeyCredential) {
        document.getElementById('passkey-not-supported-error')!.hidden = false;
        return;
    }
    const credentialRequestOptions: CredentialRequestOptions = {
        publicKey: parseRequestOptionsFromJSON(requestCredentialOptionsJSON),
    };
    if (conditionalMediation) {
        const abortController = new AbortController();
        credentialRequestOptions.signal = abortController.signal;
        credentialRequestOptions.mediation = 'conditional';
    }
    const credentials = (await navigator.credentials.get(credentialRequestOptions)) as PublicKeyCredential | null;

    if (!credentials) {
        throw new Error('No credentials returned');
    }

    // Add the PassKey login response to the PassKey form and submit it.
    const jsonCredentials = JSON.stringify(credentials);
    const formDataElement = document.getElementById(formId) as HTMLInputElement;
    formDataElement.value = jsonCredentials;
    formDataElement.form!.submit();
}
